const DSAPIQuyHoach = [
    {
        key: 72,
        text: 'Tây Ninh',
        APILink: 'https://ilis-gateway.vnpt.vn/datdaiquocgia-api/api/'
        //APILink: 'http://ilis.tayninh.gov.vn/apiv3/api/'
    },
    {
        key: 22,
        text: 'Quảng Ninh',
        APILink: 'https://ilis-gateway.vnpt.vn/datdaiquocgia-api/api/'
        //APILink: 'https://datdaiquangninhapi.vnpt.vn/api/'
    },
    {
        key: 12,
        text: 'Lai Châu',
        APILink: 'https://ilis-gateway.vnpt.vn/datdaiquocgia-api/api/'
        //APILink: 'https://datdaiquangninhapi.vnpt.vn/api/'
    },
    {
        key: 93,
        text: 'Hậu Giang',
        APILink: 'https://ilis-gateway.vnpt.vn/datdaiquocgia-api/api/'
        //APILink: 'https://datdaiquangninhapi.vnpt.vn/api/'
    },
]
export { DSAPIQuyHoach }